import { useT } from '@hana/i18n';
import { IconAlertTriangle } from '@tabler/icons-react';
import { arObh, type ArChip, type ArRow } from './ar';
import './arcards.i18n';
import s from './arm.module.css';

export const nf = (x: number): string => x.toLocaleString('vi-VN', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
export const ty = (x: number): string => (x >= 1000 ? `${nf(x / 1000)} tỷ` : `${nf(x)} tr`);

export const CHIPS: readonly (readonly [ArChip, string])[] = [['all', 'ac.all'], ['over', 'ac.over'], ['hold', 'ac.hold'], ['mine', 'ac.mine'], ['obh', 'ac.obh']];

/** Một khách ở danh sách iPad: tên · sale · DSO · cờ · chi hộ | phải thu · quá hạn. */
export function ArItem({ r, money, onOpen }: { r: ArRow; money: boolean; onOpen: () => void }) {
  const t = useT();
  const m = (x: string) => (money ? x : '•••••');
  const o = arObh(r.customer);
  return (
    <button type="button" className={s.item} onClick={onOpen}>
      <span className={s.l}>
        <b>{r.customer}</b>
        <span className={s.meta}><span title={t('ac.sale', { n: r.sale })}><i className={s.av} aria-hidden="true">{r.sale.slice(0, 2)}</i>{r.sale}</span><span>DSO {money ? r.dso : '•••'}</span></span>
        {(r.flag || o.open > 0) && (
          <span className={s.tags}>
            {r.flag && <span className={`${s.tag} ${r.block ? s.te : s.tw}`}>{r.flag}</span>}
            {o.open > 0 && <span className={`${s.tag} ${o.red ? s.te : s.tw}`} title={t('ac.obhTip')}>{t('ac.obhN', { n: nf(o.open) })}</span>}
          </span>
        )}
      </span>
      <span className={s.r}>
        <b>{m(`${nf(r.total)} tr`)}</b>
        {r.over > 0 ? <span className={s.od}><IconAlertTriangle size={13} aria-hidden="true" />{m(`${nf(r.over)} tr`)}</span> : <span className={s.ok}>{t('ac.inTerm')}</span>}
      </span>
    </button>
  );
}
